import { Component, PLATFORM_ID, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderServices } from '../../../shared/services/loader.service';

@Component({
   selector: 'app-loader',
   imports: [],
   templateUrl: './loader.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
   private readonly loaderService = inject(LoaderServices);
   private readonly platformId = inject(PLATFORM_ID);
   private readonly isBrowser = isPlatformBrowser(this.platformId);

   readonly show = signal(false);

   constructor() {
      // Subscribe to loaderStatus updates using takeUntilDestroyed to automatically clean up.
      this.loaderService.loaderStatus
         .pipe(takeUntilDestroyed())
         .subscribe((status: boolean) => {
            this.show.set(status);
         });

      // SSR Safety: Only run window-dependent or timing fallback on the browser
      if (this.isBrowser) {
         setTimeout(() => {
            this.show.set(false);
         }, 1500);
      }
   }
}
